import {
    ApptDetailRow,
    CustomizedSwitch,
    DateRow,
    DateRowStartEnd,
    EditWithIcon,
    InactivateBtb,
    InactivatedInfo,
    LinkRow,
    MinLoader,
    MoreActions,
    PhoneRow,
    SimpleTooltip,
    TextRow,
} from 'components';
import {
    ActiveInactiveStatusReverse,
    Colors,
    FindLoad,
    formatAMPMNeW,
    hooksForTable,
    Images,
    makeCapitalize,
    PermissionList,
    RolePermission,
} from 'utils';
import moment from 'moment';
import { CircularProgress } from '@mui/material';
import React from 'react';
import { clientRelationship } from '../../clientModals/constants';
import { UnitsRowByHour } from '../../../../components/table/tableRows';
import { unitStatusesEnum } from './common/constants';
import { scheduleStatuses } from '../../../schedule/core/constants';
import lockGray from '../../../../assets/images/icons/lockGray.svg';

export function getGeneralInfo(info) {
    return [
        { title: 'First Name', value: makeCapitalize(info?.firstName) },
        { title: 'Middle Name', value: makeCapitalize(info?.middleName) },
        { title: 'Last Name', value: makeCapitalize(info?.lastName) },
        { title: 'Code', value: info?.code },
        { title: 'Rendering Provider', value: info?.renderingProviderName ? info?.renderingProviderName : 'Not Set' },
        { title: 'Supervising Provider', value: info?.supervisingProviderName ? info?.supervisingProviderName : 'Not Set' },

        // {title: "Status", value: ActiveInactiveStatusReverse(info?.status)},
        // {title: "Status Date", value: moment(info?.statusDate).format("MM/DD/YYYY")},
        {
            title: { first: 'Status', second: '' },
            value: {
                first: ActiveInactiveStatusReverse(info?.status),
                second: '',
                // second: moment(info?.statusDate).format("MM/DD/YYYY") ,
            },
        },
        { title: 'Status Date', value: info?.statusDate ? moment.utc(info?.statusDate).format('MM/DD/YYYY') : '' },
        { title: 'Reason', value: info?.statusReason },
    ].filter((item) => !!item.value);
}

export function getOtherDetails(info) {
    return [
        { title: 'Gender', value: info?.gender },
        {
            title: 'Date of Birth',
            value: info?.birthday && moment.utc(info?.birthday).format('MM/DD/YYYY'),
        },
        {
            title: 'Phone Number',
            value: info?.phoneNumber,
        },
        {
            title: 'Age',
            value: info?.birthday && new Date().getFullYear() - new Date(info.birthday).getFullYear(),
        },
        { title: 'Ethnicity', value: info?.ethnicity },
        { title: 'Language', value: info?.language },
        { title: 'Family Language', value: info?.familyLanguage },
        {
            title: 'Registration Date:',
            value: info?.registrationDate && moment.utc(info?.registrationDate).format('MM/DD/YYYY'),
        },
        // { title: "Enrollment Date", value: info?.enrolmentDate ? moment(info?.enrolmentDate).format('MM/DD/YYYY') : '--'},
    ].filter((item) => !!item.value);
}

// Contact Table config

export const portalStatusEnums = {
    HAS_ACCESS: 'HAS_ACCESS',
    PENDING_INVITE: 'PENDING_INVITE',
    NO_ACCESS: 'NO_ACCESS',

    PORTAL_ACTIVE: 'PORTAL_ACTIVE',
    PORTAL_LINKED: 'PORTAL_LINKED',
};

export const contactHead = [
    { name: 'firstName', title: 'First Name', custom: false, noSearch: true },
    { name: 'relationship', title: 'Relationship', custom: false, noSearch: true },
    { name: 'address', rowName: 'formattedAddress', title: 'Address', custom: false, noSearch: true },
    { name: 'phoneNumber', title: 'Phone Number', custom: false, noSearch: true, width: '150px' },
    { name: 'phoneSecondary', title: 'Sec. Phone Number', custom: false, noSearch: true, width: '150px' },
    { name: 'email', title: 'Email Address', custom: false, noSearch: true },
    { name: 'portalStatus', title: 'Status', custom: false, disabled: true, noSearch: true },
    // RolePermission([PermissionList.CLIENT_CONTACT_MANAGE?.code]) && {
    {
        name: 'action',
        title: 'Action',
        custom: false,
        disabled: true,
        width: '100px',
        noSearch: true,
    },
];

export const contactBody = [
    {
        rowText: (item) => (
            <div className="flex-align-center">
                <p style={{ colo: '#172B4D' }}>{`${item?.firstName} ${item?.lastName ? item?.lastName : ''}`}</p>
                {/*<TextRow name={`${item?.firstName} ${item?.lastName}`} color={'#172B4D'} />*/}
                {item?.legalGuardian && <p style={{ color: '#667085', whiteSpace: 'nowrap', marginLeft: 4 }}>(Legal Guardian)</p>}
            </div>
        ),
    },
    { rowText: (item) => <TextRow name={item?.relationship} /> },
    { rowText: (item) => <TextRow name={item?.address?.formattedAddress} /> },
    { rowText: (item) => <PhoneRow phone={item?.phoneNumber} /> },
    { rowText: (item) => <PhoneRow phone={item?.phoneSecondary} /> },
    { rowText: (item) => <TextRow name={item?.email} /> },
    {
        button: (cb, item) => {
            const isActive =
                item?.portalStatus === portalStatusEnums.PORTAL_ACTIVE || item?.portalStatus === portalStatusEnums.PORTAL_LINKED;
            const isPending = item?.portalStatus === portalStatusEnums.PENDING_INVITE;
            const hasAccess = isActive || isPending;
            return (
                <div className="flex-align-center" style={{ gap: 8 }}>
                    {!hasAccess && (
                        <span className="portal-access-status-box" style={{ color: '#414651', background: '#F5F5F5' }}>
                            No Access
                        </span>
                    )}
                    {isActive && (
                        <div className="flex-align-center" style={{ gap: 8 }}>
                            <span className="portal-access-status-box" style={{ background: '#ECFDF3', color: '#027A48' }}>
                                Portal Access
                            </span>
                            {/*<span*/}
                            {/*    className="portal-access-status-box"*/}
                            {/*    onClick={() => cb('removeAccess')}*/}
                            {/*    style={{ cursor: 'pointer', fontSize: 14, color: '#D92D20', whiteSpace: 'nowrap' }}>*/}
                            {/*    Remove Access*/}
                            {/*</span>*/}
                        </div>
                    )}
                    {isPending && (
                        <div className="flex-align-center" style={{ gap: 8 }}>
                            <span className="portal-access-status-box" style={{ background: '#FFF8E1', color: '#F59E0B' }}>
                                Pending Invite
                            </span>
                            {/*<span*/}
                            {/*    className="portal-access-status-box"*/}
                            {/*    onClick={() => cb('grantAccess')}*/}
                            {/*    style={{ cursor: 'pointer', fontSize: 14, color: '#347AF0', whiteSpace: 'nowrap' }}>*/}
                            {/*    Re-invite*/}
                            {/*</span>*/}
                            {/*<span*/}
                            {/*    className="portal-access-status-box"*/}
                            {/*    onClick={() => cb('cancelInvite')}*/}
                            {/*    style={{ cursor: 'pointer', fontSize: 14, color: '#D92D20', whiteSpace: 'nowrap' }}>*/}
                            {/*    Cancel Invitation*/}
                            {/*</span>*/}
                        </div>
                    )}
                    {/*{!hasAccess && item?.email && (*/}
                    {/*    <span*/}
                    {/*        className="portal-access-status-box"*/}
                    {/*        onClick={() => cb('grantAccess')}*/}
                    {/*        style={{ cursor: 'pointer', fontSize: 14, color: '#347AF0', whiteSpace: 'nowrap' }}>*/}
                    {/*        Invite*/}
                    {/*    </span>*/}
                    {/*)}*/}
                    {/*{!!actionList.length && (*/}
                    {/*{item?.portalStatus !== portalStatusEnums?.NO_ACCESS && (*/}
                    {/*    <MoreActions*/}
                    {/*        item={item}*/}
                    {/*        buttonsList={[*/}
                    {/*            RolePermission([PermissionList.CLIENT_SET_PASSWORD?.code]) && {*/}
                    {/*                text: 'Set password',*/}
                    {/*                icon: Images.lockGray,*/}
                    {/*                actionName: 'setPassword',*/}
                    {/*            },*/}
                    {/*            isPending && { text: 'Cancel Invitation', icon: Images.closeGray, actionName: 'cancelInvite' },*/}
                    {/*        ]}*/}
                    {/*        handleAction={(e, it, name) => cb(name)}*/}
                    {/*    />*/}
                    {/*)}*/}
                    {/*)}*/}
                </div>
            );
        },
        notClickable: true,
    },
    {
        button: (cb, item) => {
            const isActive =
                item?.portalStatus === portalStatusEnums.PORTAL_ACTIVE || item?.portalStatus === portalStatusEnums.PORTAL_LINKED;
            const isPending = item?.portalStatus === portalStatusEnums.PENDING_INVITE;
            const hasAccess = isActive || isPending;

            return (
                <MoreActions
                    item={item}
                    buttonsList={[
                        !hasAccess &&
                            item?.email && {
                                text: 'Invite',
                                icon: Images.userInvite,
                                actionName: 'grantAccess',
                            },
                        isPending && {
                            text: 'Re-invite',
                            icon: Images.userInvite,
                            actionName: 'grantAccess',
                        },

                        RolePermission([PermissionList.CLIENT_SET_PASSWORD?.code]) &&
                            item?.portalStatus !== portalStatusEnums?.NO_ACCESS && {
                                text: 'Set password',
                                icon: Images.lock,
                                actionName: 'setPassword',
                            },
                        RolePermission([PermissionList.CLIENT_CONTACT_MANAGE?.code]) && {
                            text: 'Edit',
                            icon: Images.edit,
                            actionName: 'editContact',
                        },

                        isPending && {
                            text: 'Cancel Invitation',
                            icon: Images.xCircleRed,
                            actionName: 'cancelInvite',
                            originalColor: true,
                        },
                        isActive && {
                            text: 'Remove Access',
                            icon: Images.xCircleRed,
                            actionName: 'removeAccess',
                            originalColor: true,
                        },

                        RolePermission([PermissionList.CLIENT_CONTACT_MANAGE?.code]) && {
                            text: 'Delete',
                            icon: Images.redTrash,
                            actionName: 'deleteContact',
                            originalColor: true,
                        },
                    ]}
                    handleAction={(e, it, name) => cb(name)}
                />
            );
        },
        notClickable: true,
    },
];

export const ACTION_TYPE = 'GET_CLIENT_CONTACTS';

export const contactNotYet = {
    title: 'No Contact Information',
    subTitle: 'Add a contact person to stay connected with your client.',
    image: Images.noContact,
};

export const authorizationHead = [
    { name: '', title: 'Service Name', noSearch: true, custom: false },
    { name: 'service', rowName: 'cptCode', title: 'Service Code', noSearch: true, custom: false },
    { name: '', title: 'Charge Rates', noSearch: true, custom: false },
    { name: 'totalUnits', title: 'Total', noSearch: true, custom: false },
    { name: 'completedUnits', title: 'Completed ', noSearch: true, custom: false },
    { name: 'reservedUnits', title: 'Reserved', noSearch: true, custom: false },
    { name: 'availableUnits', title: 'Available', noSearch: true, custom: false },
    { name: 'availableUnits', title: 'Billed', noSearch: true, custom: false },
    { name: '', title: '% Utilization', noSearch: true, custom: false },
    { name: '', title: 'Start/End Dates', noSearch: true, custom: false },
    { name: '', title: 'Frequency Limit', noSearch: true, custom: false },
    { name: '', title: 'Appt Visible', noSearch: true, custom: false },
    RolePermission([PermissionList.CLIENT_AUTHORIZATION_MANAGE?.code]) && {
        name: '',
        title: 'Action',
        noSearch: true,
        custom: false,
        width: '100px',
    },
];
export const authorizationBody = (openModal, currentId) => {
    return [
        { rowText: (item) => <TextRow name={item?.service?.serviceTypeId?.name} textWidth={8} /> },
        { rowText: (item) => <TextRow name={item?.service?.cptCode} textWidth={8} /> },
        { rowText: (item) => <TextRow name={renderModifiers(item)} textWidth={8} /> },
        { rowText: (item) => <UnitsRowByHour info={item?.totalUnits} size={item?.service?.unitSize} textWidth={8} /> },
        {
            rowText: (item) => (
                <div>
                    <button className="units-button-style" onClick={() => openModal(item, unitStatusesEnum?.COMPLETED)}>{`${
                        item?.completedUnits ? item?.completedUnits.toFixed(2) : 0
                    } units`}</button>
                    <div style={{ marginLeft: 8 }}>
                        <UnitsRowByHour notShowHours={true} info={item?.completedUnits} size={item?.service?.unitSize} textWidth={10} />
                    </div>
                </div>
            ),
        },
        {
            rowText: (item) => (
                <div>
                    <button className="units-button-style" onClick={() => openModal(item, unitStatusesEnum?.PENDING)}>
                        {`${item?.reservedUnits ? item?.reservedUnits.toFixed(2) : 0} units`}
                    </button>
                    <div style={{ marginLeft: 8 }}>
                        <UnitsRowByHour notShowHours={true} info={item?.reservedUnits} size={item?.service?.unitSize} textWidth={10} />
                    </div>
                </div>
            ),
        },
        {
            rowText: (item) => <UnitsRowByHour info={item?.availableUnits} size={item?.service?.unitSize} textWidth={10} />,
        },
        {
            rowText: (item) => <UnitsRowByHour info={item?.billedUnits} size={item?.service?.unitSize} textWidth={10} />,
        },
        {
            rowText: (item) => {
                const { getValueByFixedNumber } = hooksForTable;
                const percentUtilization = getValueByFixedNumber((item?.completedUnits / item?.totalUnits) * 100);
                return (
                    <div className="percentage-box-style" style={{ marginLeft: '' }}>
                        <p className="percent-text-style">{`${percentUtilization}%`}</p>
                        <CircularProgress variant="determinate" value={percentUtilization} size={24} />
                    </div>
                );
            },
        },
        { rowText: (item) => <DateRowStartEnd start={item?.startDate} end={item?.endDate} format={' MM/DD/YY '} /> },
        {
            rowText: (item) =>
                item?.frequencyLimit ? (
                    <TextRow
                        name={`${frequencyLimitTypeRender(item?.frequencyLimit?.mode)}${
                            item?.frequencyLimit?.mode !== frequencyLimitModeEnums.ENTIRE_TERM ? ` / ${item?.frequencyLimit?.limit}` : ''
                        }`}
                    />
                ) : (
                    '--'
                ),
        },
        {
            button: (cb, item) => (
                <div>
                    {currentId === item?.id ? (
                        <MinLoader margin={'0'} color={Colors.ThemeBlue} position={'relative'} />
                    ) : (
                        <CustomizedSwitch checked={item?.apptVisible} handleClick={() => cb('apptVisible')} />
                    )}
                </div>
            ),
        },
        RolePermission([PermissionList.CLIENT_AUTHORIZATION_MANAGE?.code]) && {
            button: (cb, item) => {
                const hasUnits = item?.completedUnits > 0 || item?.reservedUnits > 0;
                return item?.deactivatedDate ? (
                    <div className="flex-align-center" style={{ gap: 12 }}>
                        <InactivatedInfo date={item?.deactivatedDate} title={item?.deactivatedReason} />
                        <SimpleTooltip
                            title={hasUnits ? <p>Cannot delete: service has reserved or completed units</p> : ''}
                            placement="top">
                            <button
                                onClick={() => !hasUnits && cb('delete')}
                                className="reset-btn-by-default"
                                style={hasUnits ? { opacity: 0.4, cursor: 'not-allowed' } : {}}>
                                <img src={Images.redTrash} alt="delete" />
                            </button>
                        </SimpleTooltip>
                    </div>
                ) : (
                    <div className="flex-align-center" style={{ gap: 12 }}>
                        <SimpleTooltip
                            title={hasUnits ? <p>Cannot deactivate: service has reserved or completed units</p> : ''}
                            placement="top">
                            <div>
                                <InactivateBtb
                                    handleClick={() => !hasUnits && cb('inactivate')}
                                    style={hasUnits ? { opacity: 0.4, cursor: 'not-allowed' } : {}}
                                />
                            </div>
                        </SimpleTooltip>
                        <button onClick={() => cb('edit')} className="reset-btn-by-default">
                            <img src={Images.edit} alt="edit" />
                        </button>
                        <SimpleTooltip
                            title={hasUnits ? <p>Cannot delete: service has reserved or completed units</p> : ''}
                            placement="top">
                            <button
                                onClick={() => !hasUnits && cb('delete')}
                                className="reset-btn-by-default"
                                style={hasUnits ? { opacity: 0.4, cursor: 'not-allowed' } : {}}>
                                <img src={Images.redTrash} alt="delete" />
                            </button>
                        </SimpleTooltip>
                    </div>
                );
            },
            notClickable: true,
        },
    ];
};

const renderModifiers = (authService) => {
    const { showDashIfEmpty } = hooksForTable;
    const authModifiers =
        authService?.chargeRates?.length > 1
            ? authService?.chargeRates
                  ?.filter((item) => !!item)
                  .map((item) => {
                      const modifiers = [item?.modifierTag, item?.modifierTag2, item?.modifierTag3].filter(Boolean).join(', ');
                      return `${item.name}${modifiers ? ` (${modifiers})` : ''}`;
                  })
                  .join(', ')
            : (() => {
                  const cr = authService?.chargeRates?.[0];
                  const modifiers = [cr?.modifierTag, cr?.modifierTag2, cr?.modifierTag3].filter(Boolean).join(', ');
                  return `${cr?.name}${modifiers ? ` (${modifiers})` : ''}`;
              })();
    const authModifiersDisplay = showDashIfEmpty(authModifiers);
    return authModifiersDisplay;
};
export const frequencyLimitModeEnums = {
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    ENTIRE_TERM: 'ENTIRE_TERM',
};

const frequencyLimitTypeRender = (type) => {
    switch (type) {
        case frequencyLimitModeEnums.WEEKLY:
            return 'Weekly';
        case frequencyLimitModeEnums.MONTHLY:
            return 'Monthly';
        case frequencyLimitModeEnums.ENTIRE_TERM:
            return 'Entire Term';
    }
};
export const AUTH_ACTION_TYPE = 'GET_CLIENT_AUTHORIZATION_SERV';

export const assignmentHead = [
    { name: 'staffFullName', title: 'Staff member', custom: false },
    { name: 'staffRole', title: 'Role', custom: false },
    { name: '', title: 'Assignment Date', custom: false },
    RolePermission([PermissionList.CLIENT_STAFF_ASSIGNMENT?.code]) &&
    { name: 'action', title: 'Action', custom: false, disabled: true, width: '100px' },
];

export const assignmentBody = [
    {
        rowText: (item) => (
            <LinkRow
                name={item?.staffFullName ? item.staffFullName : '--'}
                href={RolePermission([PermissionList.STAFF_READ.code]) ? `/staff/${item?.staffId}` : ''}
                checkPermission={item?.staffId ? RolePermission([PermissionList.STAFF_READ.code]) : null}
            />
        ),
    },
    { rowText: (item) => <TextRow name={item?.staffRole} textWidth={10} /> },
    { rowText: (item) => <DateRow date={item?.assignmentDate} /> },
    RolePermission([PermissionList.CLIENT_STAFF_ASSIGNMENT?.code]) &&
    {
        button: (cb) => (
            <div className="flex-align-center" style={{ gap: 16 }}>
                <div onClick={() => cb('edit')} style={{ height: '22px' }}>
                    <img src={Images.edit} alt="edit" />
                </div>
                <div onClick={() => cb('delete')} style={{ height: '22px' }}>
                    <img src={Images.remove} alt="edit" />
                </div>
            </div>
        ),
        notClickable: true,
    },
];

export const staffAssignmentNotYet = {
    title: 'No Staff Assigned',
    subTitle: 'Assign staff to get started.',
    image: Images.noContact,
};

export const ASSIGN_ACTION_TYPE = 'GET_ASSIGNED_STAFFS';

export const CLIENT_STATUSES = [
    { label: 'Active', id: 'ACTIVE' },
    { label: 'Inactive', id: 'INACTIVE', message: true },
    { label: 'FBA', id: 'FBA', message: true },
    { label: 'On Hold', id: 'ON_HOLD', message: true },
    { label: 'Waitlist', id: 'WAIT_LIST', message: true },
    { label: 'Terminated', id: 'TERMINATED', message: true },
    { label: 'Graduated', id: 'GRADUATED', message: true },
    { label: 'Intake', id: 'INVITED', message: true },
];

export const authServiceNotYet = {
    title: 'No Authorized Services',
    subTitle: 'Add services to specify what is approved for this client.',
    image: Images.noNote,
    height: '300px',
};

export const enrollmentTypeEnums = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
};
export const enrollmentTypes = [
    { name: 'Primary', id: enrollmentTypeEnums?.PRIMARY },
    { name: 'Secondary', id: enrollmentTypeEnums?.SECONDARY },
];

const supervisionBadgeStyles = {
    COMPLIANT: { background: '#ECFDF3', color: '#027A48', label: 'Compliant' },
    AT_RISK: { background: '#FFFAEB', color: '#B54708', label: 'At Risk' },
    NON_COMPLIANT: { background: '#FEF3F2', color: '#B42318', label: 'Non-Compliant' },
};

const getExpirationStatus = (expirationDate) => {
    if (!expirationDate) return null;
    const now = moment.utc();
    const expDate = moment(expirationDate).utc();
    const daysUntil = expDate.diff(now, 'days');
    if (daysUntil < 0) return 'expired';
    if (daysUntil <= 14) return 'expiring';
    return null;
};

const PAYER_COLUMN_WIDTHS = ['22%', '15%', '15%', '18%', '12%', '18%'];

/** Payers tab — AccordionFullTable config; the accordion details show the payer's insured (ClientPayerInsuredInfo). */
export const clientPayerTableInfo = (handleClick) => ({
    loadingType: CLIENT_PAYER_ACTION_TYPE,
    notYet: clientPayerNotYet,
    head: [
        { name: 'payerName', title: 'Payer', custom: false, width: '20%' },
        { name: 'enrollmentId', title: 'Member ID', custom: false, width: '20%' },
        { name: 'enrollmentDate', title: 'Enrollment Date', iconType: 'date', disabled: true, width: '15%' },
        { name: 'expirationDate', title: 'Expiration Date', iconType: 'date', disabled: true, width: '20%' },
        {
            name: 'type',
            title: 'Type',
            filterList: [{ name: 'All', id: 'All' }, ...enrollmentTypes],
            disabled: true,
            width: '10%'
        },
        { name: '', title: 'Actions', custom: false,  width: '15%', },
    ],
    body: (item) =>
        [
            { value: <TextRow name={item?.payerName} />, width: '20%' },
            { value: <TextRow name={item?.enrollmentId} />, width: '20%' },
            { value: <DateRow date={item?.enrollmentDate} />, width: '15%' },
            { value: <PayerExpiration expirationDate={item?.expirationDate} />, width: '20%' },
            {
                value:
                    item?.type === enrollmentTypeEnums.PRIMARY ? (
                        <div className="primary-enrollment">
                            <img src={Images.primaryStar} alt="" />
                            <p>Primary</p>
                        </div>
                    ) : (
                        <div className="secondary-enrollment">
                            <p>Secondary</p>
                        </div>
                    ),
                width: '10%'
            },
            {
                value: item?.terminationDate ? (
                    <InactivatedInfo date={item?.terminationDate} title={'Inactivated'} />
                ) : (
                    RolePermission([PermissionList.CLIENT_ENROLLMENT_MANAGE?.code]) && (
                        <div className="flex-align-center" style={{ gap: 12 }}>
                            <InactivateBtb handleClick={() => handleClick(item, 'inactivate')} />
                            <img style={{ cursor: 'pointer' }} src={Images.edit} alt="edit" onClick={() => handleClick(item, 'edit')} />
                        </div>
                    )
                ),
                notClickable: true,   width: '15%',
            },
        ],
});

const PayerExpiration = ({ expirationDate }) => {
    const status = getExpirationStatus(expirationDate);
    return (
        <div className="flex-align-center" style={{ gap: 8 }}>
            {expirationDate ? <DateRow date={expirationDate} /> : <TextRow name={''} />}
            {status === 'expired' && (
                <span className="client-payer-expired">
                    <img src={Images.alertError} alt="" style={{ width: 14, height: 14 }} />
                    Expired
                </span>
            )}
            {status === 'expiring' && (
                <span className="client-payer-expiring">
                    <img src={Images.alertTriangle} alt="" style={{ width: 14, height: 14 }} />
                    Expiring
                </span>
            )}
        </div>
    );
};

/** Expanded payer row — the insured stored on this enrollment's `insuredInfo`. */
export const ClientPayerInsuredInfo = ({ enrollment }) => {
    const insured = enrollment?.insuredInfo;
    const fullName = [insured?.firstName, insured?.middleName, insured?.lastName].filter(Boolean).join(' ');
    const relationship = clientRelationship.find((r) => r.value === insured?.relationshipType);
    if (!insured) {
        return <p className="client-payer-insured-empty">No insured information added</p>;
    }

    const fields = [
        { label: 'Full Name', value: fullName },
        { label: 'Phone Number', value: insured?.phoneNumber },
        { label: 'Address', value: insured?.address?.formattedAddress },
        { label: 'Relationship to Client', value: relationship?.title },
    ];

    return (
        <div className="client-payer-insured">
            <p className="client-payer-insured-title">Insured Info</p>
            <div className="client-payer-insured-fields">
                {fields.map((field) => (
                    <div key={field.label} className="client-payer-insured-field">
                        <span>{field.label}:</span>
                        <p>{field.value || '--'}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export const clientPayerNotYet = {
    title: 'No Payers Added Yet',
    subTitle: 'Start by adding a payer to track enrollments and manage billing.',
    image: Images.noClientYet,
};

export const CLIENT_PAYER_ACTION_TYPE = 'GET_CLIENT_ENROLLMENT';

export const clientNoteEnums = {
    CLIENT_NOTES: 'CLIENT_NOTES',
    SESSION_NOTES: 'SESSION_NOTES',
    MISSING_NOTES: 'UNFILLED_SESSION_NOTES',
};

export const clientNoteTypes = [
    { name: 'Client Notes', id: clientNoteEnums.CLIENT_NOTES },
    { name: 'Session Notes', id: clientNoteEnums.SESSION_NOTES },
    // { name: 'Missing Notes', id: clientNoteEnums.MISSING_NOTES },
];

export const formHead = [
    { name: 'name', title: 'Form Name', custom: false },
    { name: '', title: 'Created By', custom: false },
    { name: '', title: 'Created Date', custom: false },
    { name: '', title: 'Send to', custom: false },
    { name: '', title: 'Status', custom: false },
    { name: '', title: 'Action', custom: false, width: '100px' },
];

export const formBody = [
    {
        rowText: (item) => (
            <div className="flex-align-center">
                <p style={{ colo: '#172B4D' }}>{`${item?.firstName} ${item?.lastName}`}</p>
                {/*<TextRow name={`${item?.firstName} ${item?.lastName}`} color={'#172B4D'} />*/}
                {item?.legalGuardian && <p style={{ color: '#667085', whiteSpace: 'nowrap', marginLeft: 4 }}>(Legal Guardian)</p>}
            </div>
        ),
    },
    { rowText: (item) => <TextRow name={item?.relationship} /> },
    { rowText: (item) => <TextRow name={item?.address?.formattedAddress} /> },
    { rowText: (item) => <PhoneRow phone={item?.phoneNumber} /> },
    { rowText: (item) => <TextRow name={item?.email} /> },
    RolePermission([PermissionList.CLIENT_CONTACT_MANAGE?.code]) && {
        button: (cb) => (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <img style={{ cursor: 'pointer', marginRight: '16px' }} src={Images.edit} alt="edit" onClick={() => cb('editContact')} />
                <img style={{ cursor: 'pointer' }} src={Images.remove} alt="remove" onClick={() => cb('deleteContact')} />
            </div>
        ),
        notClickable: true,
    },
];

export const FORM_ACTION_TYPE = 'GET_CLIENT_FORMS';

export const formNotYet = {
    title: 'No Forms Added Yet',
    subTitle: 'Start by designing your first form to streamline data collection.',
    image: Images.noContact,
};
